import { Injectable } from '@angular/core';
import { environment } from '@app-environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnvService {
  
  
  global:any = {};

  
  APP_NAME = 'clinic_portal_app';
  VERSION = '1.0.0';
  LOCALE = 'en';
  STRATEGY = 'vetpay';
  API_URL = environment.apiURL;

  VETPAY_API_STATUS_URL = environment.vet_pay_status;
  delinquentPortal = false;

  trustExpiry = 10 * 24 * 60 * 60 * 1000;
  idlePeriod = 10 * 60 * 1000;

  constructor() {
	
   }


}
